// extracted by mini-css-extract-plugin
export default {"header":"Header__header--aR6cX","beta":"Header__beta--74IK3","tagContent":"Header__tagContent--l2MJZ","text":"Header__text--aCPWu","tooltip":"Header__tooltip--JpR2v"};